import { createApp } from 'vue';
import App from './App.vue';
import 'core-js/modules/es.array.find-last';
import 'core-js/modules/es.array.find-last-index';
import countryListOptions from '@/lists/countryList.js';
import phoneCodeList from '@/lists/phoneCodeList.js';
import capitalizeDirective from '@/utils/capitalize.js';
import autoSlash from '@/utils//autoSlash.js';
import router from './router';
import store from './store';

// Styles
import '@/scss/style.scss';
// Plugins
import vuetify from '@/plugins/vuetify';

const app = createApp(App);

app.config.globalProperties.$store = store;
app.directive('capitalize', capitalizeDirective);
app.directive('auto-slash', autoSlash);
app
  .use(store)
  .use(vuetify)
  .provide('countryListOptions', countryListOptions)
  .provide('phoneCodeList', phoneCodeList)
  .use(router)
  .mount('#app');
